import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopProgressBar from "../../components/common/top-progress-bar/TopProgressBar";

function AuthLayout() {
  const location = useLocation();

  return (
    <div className="d-flex flex-column min-vh-100">
      <TopProgressBar />
      <Header />
      <main className="flex-grow-1 bg-body-secondary">
        <div key={location.pathname} className="page-enter">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default AuthLayout;
